import * as ActionType from '../constants/ActionType'
import * as api from '../api/api';
import { updateIntl } from 'react-intl-redux';

export function requestStart() {
    return {
        type: ActionType.REQUEST_START
    }
}

export function requestSuccess() {
    return {
        type: ActionType.REQUEST_SUCCESS
    }
}

export function getAppConfig() {
    return (dispatch, getState) => {
        if ( isAppConfigLoaded(getState()) ) {
            // Let the calling code know there's nothing to wait for.
            return Promise.resolve();
        } else {
            // Dispatch a thunk from thunk!
            return dispatch(fetchAppConfig());
        }
    };
}

export function getOrganisationUsers() {
  return (dispatch, getState) => {
    if ( areOrganisationUsersLoaded(getState()) ) {
      // Let the calling code know there's nothing to wait for.
      return Promise.resolve();
    } else {
      // Dispatch a thunk from thunk!
      return dispatch(fetchOrganisationUsers());
    }
  };
}

function requestAppConfig() {
    return {
        type: ActionType.REQUEST_APP_CONFIG
    }
}

function receiveAppConfig(payload) {
    return {
        type: ActionType.RECEIVE_APP_CONFIG,
        payload: payload
    }
}

function fetchAppConfig() {
    // Thunk middleware knows how to handle functions.
    // It passes the dispatch method as an argument to the function,
    // thus making it able to dispatch actions itself.

    return function (dispatch, getState) {

        dispatch(requestAppConfig());

        api.getAppConfig()
            .then(function(response) {
                return api.handleStatus(response, dispatch)
            })
            .then(json =>
                // We can dispatch many times!
                // Here, we update the app state with the results of the API call.
                {
                    dispatch(receiveAppConfig(json));

                    // load the default intl messages
                    // hardcoded fallback locales
                    let defaultLocale = 'en_GB';
                    let intlLocale = 'en-GB';
                    let messages = {};

                    // defaultlocale, defined in api config
                    if (json && json.configuration && json.configuration.defaultLocale) {
                        defaultLocale = json.configuration.defaultLocale;
                    }

                    // locale set by global var in
                    let locale = 'en_GB';
                    if (window && window.plskAppLocale) {
                        locale = window.plskAppLocale;
                    }

                    if (json && json.configuration && json.configuration.messages && json.configuration.messages[`${locale}`]) {
                        messages = json.configuration.messages[`${locale}`];
                        intlLocale = locale.replace('_', '-');
                    } else if (json && json.configuration && json.configuration.messages && json.configuration.messages[`${defaultLocale}`]) {
                        messages = json.configuration.messages[`${defaultLocale}`];
                        intlLocale = defaultLocale.replace('_', '-');
                    }

                    const defaultIntl = {
                        locale: intlLocale,
                        messages: messages
                    };

                    dispatch(updateIntl(defaultIntl));
                }

            )
        // .catch(error => {
        //     console.log(`Request failed: ${error}`);
        // })
        ;

        // In a real world app, you also want to
        // catch any error in the network call.
    }
}

function switchLocale(locale) {

}

function requestOrganisationUsers() {
  return {
    type: ActionType.REQUEST_ORGANISATION_USERS,
  }
}

function receiveOrganisationUsers(payload) {
  return {
    type: ActionType.RECEIVE_ORGANISATION_USERS,
    payload: payload
  }
}

function fetchOrganisationUsers() {
  // Thunk middleware knows how to handle functions.
  // It passes the dispatch method as an argument to the function,
  // thus making it able to dispatch actions itself.

  return function (dispatch, getState) {

    dispatch(requestOrganisationUsers());

    api.getOrganisationUsers()
      .then(function(response) {
        return api.handleStatus(response, dispatch)
      })
      .then(json =>
          // We can dispatch many times!
          // Here, we update the app state with the results of the API call.
        {
          dispatch(receiveOrganisationUsers(json));
        }

      )
    // .catch(error => {
    //     console.log(`Request failed: ${error}`);
    // })
    ;

    // In a real world app, you also want to
    // catch any error in the network call.
  }
}

function isAppConfigLoaded(globalState) {
    if (globalState.app.config === null) {
        return false;
    }
    return true;
}

function areOrganisationUsersLoaded(globalState) {
  if (globalState.app.organisationUsers === null) {
    return false;
  }
  return true;
}


// WEBPACK FOOTER //
// ./src/js/actions/app.js